<template>
    <v-container>
        <Snackbar v-model="snackbar.show" :type="snackbar.type" :message="snackbar.responseMessage" />
        <v-toolbar dense short flat color="blue">
            <v-toolbar-title>Fees</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-tooltip left>
                    <template v-slot:activator="{on}">
                        <v-btn icon @click="addFee" v-on="on"><v-icon>add</v-icon></v-btn>
                    </template>
                    <span>Add Fee</span>
                </v-tooltip>
            </v-toolbar-items>
        </v-toolbar>
        <v-data-table
            dense
            loading-text="Loading Items from server, please wait..."
            :loading="loading"
            :headers="headers" 
            :items="records"
            :server-items-length="serverItemTotal"
            :options.sync="pageOptions"
            :footer-props="footerProps"
        >

            <template v-slot:item.action="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{on}">
                        <v-icon size="25" @click="editFee(item)" v-on="on">edit</v-icon>
                    </template>
                    <span>Edit Fee</span>
                </v-tooltip>
            </template>
            
            <template v-slot:item.amount="{ item }">
                <span>&#8369; {{item.amount}}</span>
            </template>

            <template v-slot:item.rate="{ item }">
                <span>{{item.rate}} %</span>
            </template>

            <template v-slot:item.active="{ item }">
                <v-simple-checkbox :value="Boolean(item.active)" disabled></v-simple-checkbox>
            </template>
        </v-data-table>

        <v-dialog v-model="showDialog" width="500" height="500">
            <Details 
                :action="action"
                :feeRecord="feeRecord"
                v-on:fee-response="showActionResponse"
                v-on:close-form="closeDialog"
            ></Details>
        </v-dialog>

    </v-container>
</template>

<script>
import Details from './Details'
import Snackbar from '@/components/Snackbar'

export default {
    components: {
        Details,
        Snackbar
    },
    data() {
        return {
            action: null,
            showDialog: false,
            loading: false,
            serverItemTotal: 0,
            feeRecord: null,
            pageOptions: {
                page: 1,
                itemsPerPage: 20
            },
            footerProps: {
                itemsPerPageOptions: [20, 40, 80, 100],
                itemsPerPageText: "Records per Page"
            },
            snackbar: {
                responseMessage: "",
                show: false,
                type: "success"
            },
            records: [],
            headers: [
                { text: 'Fee', value: 'name', sortable: false },
                { text: 'Amount', value: 'amount', sortable: false },
                { text: 'Rate', value: 'rate', sortable: false },
                { text: 'Active', value: 'active', align: 'center', sortable: false },
                { text: 'Action', value: 'action', align: 'center', sortable: false }
            ]
        }
    },
    mounted() {
        this.loadFees();
    },
    watch: {
        showDialog(value) {
            if(!value) this.loadFees()
        }
    },
    methods: {
        loadFees() {
            const self = this
            self.loading = true

            let paging = {
                limit: self.pageOptions.itemsPerPage,
                offset: self.pageOffset
            }

            this.$axios.get(`/fees`).then((result) => {
                self.records = result.data.data
                self.serverItemTotal = result.data.data.length
                self.loading = false
            }).catch((error) => {
                self.showSnackbarMessage(error.message, false)
            })
        },
        addFee() {
            this.action = 'add'
            this.showDialog = true
        },
        editFee(item) {
            this.action = 'update'
            this.feeRecord = item
            this.showDialog = true
        },
        showActionResponse(message, success = true) {
            this.closeDialog()
            this.showSnackbarMessage(message, success)
        },
        closeDialog() {
            this.showDialog = false
            this.feeRecord = null
        },
        showSnackbarMessage(message, success = true) {
            this.snackbar.type = success ? "success" : "error"
            this.snackbar.responseMessage = message
            this.snackbar.show = true
        }
    },
}
</script>